import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import React, { FunctionComponent, useState } from 'react';
import { useThemeContext } from 'shared/context/themeContext';

type Props = {
  passengers: any;
  idTravel: number;
};

const PassengersItem: FunctionComponent<Props> = ({
  passengers = [],
  idTravel
}) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Asegura que passengers sea un arreglo
  const passengerList: string[] = Array.isArray(passengers) ? passengers : [];

  if (passengerList.length === 0) {
    return <span className="text-xs text-gray-400">-</span>;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation(); // Evita accionar la fila de la tabla
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event?: any) => {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? `passengers-popover-${idTravel}` : undefined;

  // Formateo del texto de vista previa (resumen en 1 sola línea)
  const firstPassenger = passengerList[0] || '';
  const remainingCount = passengerList.length - 1;
  const summaryText =
    remainingCount > 0
      ? `${firstPassenger} (+${remainingCount})`
      : firstPassenger;

  return (
    <div
      className="flex items-center gap-1.5 w-32 "
      onClick={(e) => e.stopPropagation()} // Aislamiento de eventos de fila
    >
      {/* Texto truncado a una sola línea */}
      <span
        className="text-xs text-gray-700 dark:text-ink-dark truncate block flex-1"
        title={passengerList.join(', ')}
      >
        {summaryText}
      </span>

      {/* Botón con el ícono e indicador para desplegar el Popover */}
      <button
        type="button"
        onClick={handleClick}
        className="flex items-center rounded-full gap-1 py-1 px-2text-inkMuted hover:text-black dark:text-inkMuted-dark dark:hover:text-white transition-colors flex-shrink-0"
        title="Ver todos los pasajeros"
      >
        <FontAwesomeIcon icon={faUser} size="xs"/>
        <span className="text-xs font-semibold">{passengerList.length}</span>
      </button>

      {/* Popover con la tabla detallada de pasajeros */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          style: {
            borderRadius: 8
          }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <TableContainer
          style={{
            maxHeight: 300,
          }}
        >
          <Table aria-label="tabla de pasajeros" stickyHeader>
            <TableHead>
              <TableRow onClick={(e) => e.stopPropagation()}>
                <TableCell>
                  <div className="flex justify-between items-center py-1">
                    <span className="text-xs font-bold text-ink dark:text-ink-dark uppercase tracking-wider">
                      Pasajeros ({passengerList.length})
                    </span>
                    <span className="text-xs text-inkMuted dark:text-inkMuted-dark font-mono">
                      #{idTravel}
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {passengerList.map((passenger, index) => (
                <TableRow
                  key={`${passenger}-${index}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <TableCell align="left">
                    <span className="text-xs text-inkMuted dark:text-inkMuted-dark block truncate">
                      {passenger}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Popover>
    </div>
  );
};

export default PassengersItem;
